import { hasAnyRole, normalizeRole } from './sistemaAuthz';

export const isAdminRole = (roles?: string[] | null): boolean => {
  if (!roles?.length) return false;
  return hasAnyRole(roles, ['admin', 'superadmin']);
};

export const isAdminRoleName = (role?: string | null): boolean => {
  if (!role?.trim()) return false;
  const r = normalizeRole(role);
  return r === 'admin' || r === 'superadmin';
};
